/**
 * Enum for storing all of the different mandatory field types. When creating a new mandatory field, add it's name in this
 * Enum.
 */
export enum ValidationFieldsEnum {
	MAIN_MEDIA = 'main_media',
}
